const createHTMLElement = require("../dom/createHTMLElement");

/**
 * @return {HTMLElement}
 */
module.exports = function loadingAnimation() {
    return createHTMLElement(`
        <figure class="itbl-b-circle__loader">
            <div class="loader">
                <svg class="circular" viewbox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
                </svg>
            </div>
        </figure>
    `);
}